import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/aleksundshantu/deepl-unmute-frontend/apps/template-standard/src/app/layout.client.tsx");
;
import(/* webpackMode: "eager" */ "/builds/aleksundshantu/deepl-unmute-frontend/apps/template-standard/src/style.scss");
